var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5761 5.69513V0.634406C16.5761 0.284063 16.2924 0 15.9424 0H14.9285C14.5785 0 14.2944 0.284063 14.2944 0.634406V5.69513H9.70573V0.634406C9.70577 0.284063 9.42204 0 9.0717 0H8.05816C7.70782 0 7.42409 0.284063 7.42409 0.634406V5.69513H4.77991V7.84959H19.2204V5.69513H16.5761Z",
    fill: "#B7E4EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77975 11.4988C4.77975 14.0925 6.32409 16.3243 8.54245 17.3294V18.7215C8.54245 19.39 9.0847 19.9322 9.75319 19.9322H14.2468C14.9156 19.9322 15.4575 19.39 15.4575 18.7215V17.3294C17.6762 16.3243 19.2202 14.0925 19.2202 11.4988V8.82837H4.77975V11.4988Z",
    fill: "#B7E4EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3729 20.8297H10.6271V24.0001H13.3729V20.8297Z",
    fill: "#B7E4EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.8ae446deb89c8316ecf24f82e2b44495.svg";
export { ForwardRef as ReactComponent };